import { render, staticRenderFns } from "./historicalProcess.vue?vue&type=template&id=2b20e4ad&scoped=true"
import script from "./historicalProcess.vue?vue&type=script&lang=js"
export * from "./historicalProcess.vue?vue&type=script&lang=js"
import style0 from "./historicalProcess.vue?vue&type=style&index=0&id=2b20e4ad&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b20e4ad",
  null
  
)

export default component.exports